import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { forkJoin } from 'rxjs';
import { ValidationMsgs } from 'src/app/core/Constants/static';
import { InputDatepicker } from 'src/app/shared/components/datepicker_v2/interfaces/input-datepicker';

@Component({
  selector: 'app-prov-regulator',
  templateUrl: './prov-regulator.component.html',
  styleUrls: ['./prov-regulator.component.css']
})
export class ProvRegulatorComponent implements OnInit {
  showReg: boolean = true;
  @Input() formGroupName!: string;
  @Input() submitted: boolean = false;
  @Input() isEdit :boolean = false;
  regDetailsForm!: FormGroup;
  regulatorList: any[] = [];
  validationMsg = ValidationMsgs.datePattern;
  EndDateError = ValidationMsgs.EndDateError;
  startDateError = ValidationMsgs.startDateError;

  feild_startDate = {
    type: 'datetimepicker',
    inputClassName: ["form-control date-input"],
    selectedDateClassName: ['selectedDate', 'form-control'],
    arrowClassName: ['arrow'],
    dayClassName: ['dd'],
    todayClassName: ['now'],
    monthClassName: ['mtn'],
    monthListClassName: ['monthlist'],
    yearBtnHeadClassName: ['YY'],
    yearListClassName: ['yList'],
    range: true,
    locale: 'en-IN',
    placeholder: 'DD/MM/YYYY',
    options: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    classname: ['form-control'],
  };
  validity_date_v2:InputDatepicker={
    type: 'datepicker_v2',
    name: 'Validity',
    range: true,
    locale: 'en-IN',
    required : true,
    inputClassName:'form-control date-input',
    selectedDateClassName: 'selectedDate',
    arrowClassName: 'arrow',
    dayClassName: 'dd',
    todayClassName: 'now',
    monthClassName: 'mtn',
    datepickerHeaderClass:'', //classes for the active date div
    headerButtonClass:'', // classes for month-year buttons
    yearClassName:'',
    options: {year: 'numeric', month: '2-digit', day: '2-digit'},
    classname: '',
    timer:false,
    disabled:false, // disables the datepicker
    seperator:' to ', // seperator b/w dates
    startDatePlaceHolder:'DD/MM/YYYY',
    dateFormat:'DD/MM/YYYY' ,// dd-mm-yyyy | dd/mm/yyyy
    dateSeperator:'/', // seperator b/w dd,mm,yyyy
  }
  constructor(
    private rootFormGroup: FormGroupDirective,
    private form: FormBuilder,
    private provPayerApiService: ProvPayerApiService
  ) { }

  ngOnInit(): void {
    this.getMasterLists();
    this.regDetailsForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
  }
  getMasterLists() {
    forkJoin([
      this.provPayerApiService.getRegulatorList(),
    ]).subscribe({
      next: (responseList) => {
        this.regulatorList = responseList[0]
      }
    })
  }
  get regulatorForm(): FormGroup[] {
    return (
      this.regDetailsForm?.controls['regulatorArray'] as FormArray
    )?.controls as FormGroup[];
  }

  get regulatorDetailsArray(): FormArray {
    return this.regDetailsForm?.controls['regulatorArray'] as FormArray;
  }

  addContactForm() {
    const newRegulator = this.form.group({
      regulatorId: new FormControl(null),
      facility: new FormControl(null),
      date: new FormControl(null,),

    });
    this.regulatorDetailsArray.push(newRegulator);
  }
  removeElement(index: number, form: FormGroup) {
    this.regulatorDetailsArray.removeAt(index);
  }

  selectedValue(event: any, formElem: string, form: FormGroup) {

    if (!event) {
      form.controls[formElem].patchValue(null);
    }
    form.controls[formElem].patchValue(event);
  }
}
